import { Icon, SpaceBetween, TextContent } from '@amzn/awsui-components-react';
import { useLocalizedText } from '../../hooks/localizedText';

export function AmbassadorOffboardingHelp() {
  const { t } = useLocalizedText(['ambassadors', 'translation']);

  return (
    <div data-testid="offboarding-help">
      <SpaceBetween size="m" direction="vertical">
        <div>
          <h3>{t('ambassadorOffboarding.help.transferYourKnowledge')}</h3>
          <ul>
            <li>{t('ambassadorOffboarding.help.completeAHandover')}</li>
            <li>{t('ambassadorOffboarding.help.shareInformation')}</li>
          </ul>
        </div>
        <div>
          <h3>{t('ambassadorOffboarding.help.documentKeyInformation')}</h3>
          <ul>
            <li>{t('ambassadorOffboarding.help.documentUpcomingEvents')}</li>
            <li>{t('ambassadorOffboarding.help.transferAnyPendingTasks')}</li>
          </ul>
        </div>
        <div>
          <h3>{t('ambassadorOffboarding.help.administrativeUpdates')}</h3>
          {t('ambassadorOffboarding.help.youllBeRemovedFromCommunityAmbassadorMailingLists')}
        </div>
        <hr data-volunteer-center-hr />
        <div>
          <SpaceBetween size="m" direction="vertical">
            <SpaceBetween size="s" direction="horizontal">
              <h3 style={{ display: 'inline' }}>{t('ambassadorOffboarding.help.learnMore')}</h3>
              <Icon name="external" />
            </SpaceBetween>
            <TextContent>
              <SpaceBetween size="xxs" direction="vertical">
                <a
                  href="https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('ambassadorOffboarding.help.seeOurWiki')}
                </a>
                <a
                  href="https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/FAQs/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('ambassadorOffboarding.help.readOurFAQs')}
                </a>
              </SpaceBetween>
            </TextContent>
          </SpaceBetween>
        </div>
      </SpaceBetween>
    </div>
  );
}
